import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/api.utils';
import api from '@/utils/api.utils';

export interface Prompt {
  id: number;
  prompt_text: string;
  word_count: number;
  primary_category_name: string;
}

export const usePrompts = (type: string, itemId?: number) => {
  return useQuery<Prompt[], Error>({
    queryKey: ['prompts', type, itemId],
    queryFn: async () => {
      if (!itemId) return [];
      

      const response =await api.get(`${API.BASE_URL}/api/v1/prompts/promptable/${type}/${itemId}`);
      return response.data;
    },
    enabled: !!itemId, // Enable when we have a valid itemId
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
  });
};
